<template>
    <div>
        <div class="footer">
            <div class="con">
                <div>
                    <router-link style="color: #fff; font-size: 18px;" to="/">首页</router-link>
                    <div class="contentItem" style="margin-top: 40px;">我们的优势</div>
                    <div class="contentItem">公司简介</div>
                    <div class="contentItem">著作权登记证书</div>
                    <div class="contentItem">企业资质</div>
                </div>
                <div>
                    <router-link style="color: #fff; font-size: 18px;"  to="/case">产品中心</router-link>
                    <div class="contentItem" style="margin-top: 40px;">政府服务产品</div>
                    <div class="contentItem">企业服务产品</div>
                </div>
                <div>
                    <router-link style="color: #fff; font-size: 18px;"  to="/newslist1">行业案例</router-link>
                    <div class="contentItem" style="margin-top: 40px;">政府机关行业</div>
                    <div class="contentItem">央国企行业</div>
                </div>
                <div>
                    <router-link style="color: #fff; font-size: 18px;"  to="/about">企业资讯</router-link>
                    <div class="contentItem" style="margin-top: 40px;">企业风采</div>
                </div>
                <div>
                    <router-link style="color: #fff; font-size: 18px;"  to="/contact">招贤纳士</router-link>
                    <div class="contentItem" style="margin-top: 40px;">后端研发工程师</div>
                    <div class="contentItem">前端研发工程师</div>
                    <div class="contentItem">项目开发经理</div>
                </div>
                <div style="width: 230px;">
                    <div>联系我们</div>
                    <div class="contentItem" style="margin-top: 40px;text-align: left;">
                        <div>邮箱: hr@hbsoftware.cn</div>
                        <div style="text-indent: 2.6em;">hbsoftware@hbsoftware.cn</div>
                    </div>
                    <div class="contentItem" style="text-align: left;">地址:广州市越秀区沿江中路313号第十一层自编1103-04 房</div>
                </div>
            </div>
            <div style="padding: 20px;color: #fff;">
                <div style="margin-bottom: 25px;">Copyright © 2024 广州汇柏软件科技有限公司 版权所有</div>
                <div>粤ICP备18128427号-1</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'foot',
    data(){
        return {
            wximg:'',
            beian_num:''
        }
    },
    methods:{
        getwximg(){
            this.$axios.get('/api/about/list')
                .then((res) => {
                    var i = 4
                    this.wximg = res.data.list[i].wechat_code_url
                    this.beian_num = res.data.list[i].beian_num
                    })

        }
    },
    mounted(){
        this.getwximg()
    }
}
</script>
<style lang="less" scoped>
.footer{
    width:100%;
    // height: 400px;
    background-color: #2C2D35;
}

.con {
    width: 1200px;
    padding: 40px 0 20px;
    display: flex;
    justify-content: space-between;
    color: #fff;
    border-bottom: 1px solid #fff;
    display: flex;
    text-align: left;
}

.contentItem {
    margin-bottom: 8px;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue